// Colors use the USK Design System status tokens (text / bg / border / solid)
export const APPROVAL_CONFIG = {
    DRAFT: {
        label: "Draft",
        color: "var(--color-neutral-text)",
        bg: "var(--color-neutral-bg)",
        border: "var(--color-neutral-border)",
        dot: "var(--color-neutral)",
        iconName: "solar:document-bold",
    },
    SUBMITTED: {
        label: "Submitted",
        color: "var(--color-info-text)",
        bg: "var(--color-info-bg)",
        border: "var(--color-info-border)",
        dot: "var(--color-info)",
        iconName: "solar:check-circle-bold",
    },
    UNDERREVIEW: {
        label: "Under Review",
        color: "var(--color-info-text)",
        bg: "var(--color-info-bg)",
        border: "var(--color-info-border)",
        dot: "var(--color-info)",
        iconName: "solar:eye-bold",
    },
    APPROVED: {
        label: "Approved",
        color: "var(--color-success-text)",
        bg: "var(--color-success-bg)",
        border: "var(--color-success-border)",
        dot: "var(--color-success)",
        iconName: "solar:shield-check-bold",
    },
    REJECTED: {
        label: "Rejected",
        color: "var(--color-error-text)",
        bg: "var(--color-error-bg)",
        border: "var(--color-error-border)",
        dot: "var(--color-error)",
        iconName: "solar:shield-slash-bold",
    },
    CANCELPENDING: {
        label: "Cancel Pending",
        color: "var(--color-warning-text)",
        bg: "var(--color-warning-bg)",
        border: "var(--color-warning-border)",
        dot: "var(--color-warning)",
        iconName: "solar:clock-circle-bold",
    },
    CANCELLED: {
        label: "Cancelled",
        color: "var(--color-neutral-text)",
        bg: "var(--color-neutral-bg)",
        border: "var(--color-neutral-border)",
        dot: "var(--color-neutral)",
        iconName: "solar:close-circle-bold",
    },
};
